import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Log } from 'app/core/logging/log';

@Component({
    selector: 'app-modal-login-component',
    templateUrl: './modal-login.component.html',
    styleUrls: ['./modal-login.component.scss']
})
export class ModalLoginComponent implements OnInit {

    goTo: string = 'signin';

    constructor(
        public activeModal: NgbActiveModal
    ) {
        
    }

    ngOnInit() {}
    
    _goTo(value:string){
        Log.debug('_goTo', {value})
        this.goTo = value;
    }

    callbackSignin(){
        Log.debug('callbackSignin');
        this.activeModal.dismiss();
    }

    callbackSignup(){
        Log.debug('callbackSignup');
        this.activeModal.dismiss();
    }

}
